import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPhone, FaWhatsapp, FaArrowUp } from 'react-icons/fa';
import './FloatingActions.css';

const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="floating">
      <motion.a
        href="tel:+919004068462"
        className="floating__btn floating__btn--phone"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, x: 60 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5 }}
        aria-label="Call Amresh"
        title="Call Now"
      >
        <FaPhone />
        <span className="floating__pulse" />
      </motion.a>

      <motion.a
        href="https://api.whatsapp.com/send/?phone=919004068462&text=Hi+Amresh,+I+want+to+discuss+a+project"
        target="_blank"
        rel="noopener noreferrer"
        className="floating__btn floating__btn--whatsapp"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, x: 60 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.6 }}
        aria-label="WhatsApp"
        title="WhatsApp"
      >
        <FaWhatsapp />
      </motion.a>

      <AnimatePresence>
        {showTop && (
          <motion.button
            className="floating__btn floating__btn--top"
            onClick={scrollToTop}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            whileHover={{ scale: 1.1 }}
            aria-label="Back to top"
            title="Back to Top"
          >
            <FaArrowUp />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingActions;
